<template lang="html">
  <v-flex
    xs12
    pa-0
  >
    <div
      style="background-color:#272822; position: relative"
      class="pt-4 si-code-eidtor"
    >
      <v-slide-y-transition>
        <span
          v-if="hasChanges"
          class="si-code-editor-has-changes error white--text py-1 px-3"
        >Unsaved changes...</span>
      </v-slide-y-transition>
      <codemirror
        ref="cm"
        v-model="code"
        :options="cmOption"
        @blur="blur"
      />
    </div>
    <v-slide-y-transition>
      <v-layout
        v-if="hasChanges && !hideCommit"
        wrap
        ma-0
        mt-3
      >
        <v-spacer />
        <v-btn
          text
          color="grey"
          @click="cancel"
        >
          cancel
        </v-btn>
        <v-btn
          color="error"
          @click="commit"
        >
          <v-icon left>
            publish
          </v-icon>Commit
        </v-btn>
      </v-layout>
    </v-slide-y-transition>
  </v-flex>
</template>

<script>
import { clone } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/theme/monokai.css'
import 'codemirror/addon/selection/active-line.js'

export default {
  props: {
    path: String,
    value: String,
    hideCommit: Boolean,
    hasChange: Boolean
  },
  data () {
    return {
      internalValue: clone(this.value),
      baseValue: clone(this.value),
      changeValue: '',
      hasChanges: false,
      cmOption: {
        viewportMargin: Infinity,
        tabSize: 2,
        styleActiveLine: false,
        lineNumbers: true,
        styleSelectedText: false,
        line: true,
        foldGutter: true,
        mode: 'text/javascript',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
        extraKeys: {
          'Ctrl': 'autocomplete',
          'Ctrl-S': () => {
              this.commit(); //function called when 'ctrl+s' is used when instance is in focus
          }
        }
      }
    }
  },
  computed: {
    // ...mapGetters([]),
    code: {
      get: function () {
        return this.internalValue
      },
      set: function (v) {
        this.hasChanges = Boolean(v !== this.baseValue)
        this.internalValue = v
        // this.$emit('input', v)
      }
    }
  },
  watch: {
    value: {
      handler: function (v) {
        if (v !== this.code) {
          this.code = v
          this.baseValue = v
          this.hasChanges = false
        }
      }
    },
    hasChanges (v) {
      this.$emit('update:hasChange', v)
    }
  },
  mounted () {
    setTimeout(() => {
      this.$refs.cm.refresh()
    }, 600)
    this.init()
  },
  methods: {
    init () {
      if (this.path) {
        rtdb.ref(this.path).once('value', s => {
          this.code = s.val()
          this.baseValue = s.val()
          this.$nextTick(() => {
            this.hasChanges = false
          })
        })
      }
    },
    cancel () {
      this.code = this.baseValue
      this.changeValue = this.code
      this.$emit('change', this.code)
      this.$nextTick(() => {
        this.hasChanges = false
      })
    },
    commit () {
      this.$emit('commit', this.code)
      this.baseValue = this.code
      this.$nextTick(() => {
        this.hasChanges = false
      })
      if (this.path) {
        rtdb.ref(this.path).set(this.code)
      }
    },
    blur () {
      if (this.changeValue !== this.code) {
        this.changeValue = this.code
        this.$emit('change', this.code) // because change doesn't work
      }
    }
  }
}
</script>

<style lang="css">
.CodeMirror-scrollbar-filler{
  display: none !important;
}
.si-code-editor-has-changes {
  border-radius: 0 0 3px 3px;
  position: absolute;
  left: 50%;
  top: 0;
  z-index: 2;
  transform: translateX(-50%);
}

.si-code-eidtor,
.CodeMirror,
.CodeMirror pre,
.CodeMirror span
{
  font-size: 14px !important;
}
.si-code-eidtor .CodeMirror{
  height: auto;
  min-height: 200px;
}
</style>
